import { createContext, useContext } from "react";
import { useSession } from "../hooks";
const Context = createContext();

export const SessionProvider = ({ children }) => {
  return <Context.Provider value={useSession()}>{children}</Context.Provider>;
};

export const useSessionContext = () => useContext(Context);
